var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3649_2304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4218 12.9516L17.6304 14.8041C17.9436 14.985 18.0449 15.3959 17.8686 15.7013C17.6869 16.016 17.2948 16.1297 16.9725 15.9436L13.7095 14.0598C13.3754 14.3192 12.9558 14.4737 12.5 14.4737C11.41 14.4737 10.5263 13.59 10.5263 12.5C10.5263 11.6406 11.0755 10.9096 11.8421 10.6386V4.60976C11.8421 4.24393 12.1473 3.94737 12.5 3.94737C12.8633 3.94737 13.1579 4.25381 13.1579 4.60976V10.6386C13.9245 10.9096 14.4737 11.6406 14.4737 12.5C14.4737 12.6554 14.4557 12.8066 14.4218 12.9516ZM12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#998147"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3649_2304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeFilled);
export default __webpack_public_path__ + "static/media/time-filled.e285fa1fc4c2f0b330a8d68a6804e3e5.svg";
export { ForwardRef as ReactComponent };